module.exports = __webpack_public_path__ + "img/img3.e0e44307.png";